import { ThemePlusTypes } from "@styles/types";
import { PalletThemeColors } from "@styles/utils";

export default (colors: PalletThemeColors): ThemePlusTypes["aiCoach"] => {
  return {
    dropdownBorderPrimary: "#F56D34",
    dropdownBorderSecondary: "#0881F9",
    conversation: {
      userMessage: {
        background: colors.primary.base,
        color: colors.white,
      },
      reset: {
        textColor: colors.secondary.darker,
      },
    },
    error: {
      iconColor: colors.red.base,
    },
    note: {
      textColor: colors.secondary.darker,
    },
  };
};
